import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { Button } from '../components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { MapPin, Clock, Phone, Mail, Navigation } from 'lucide-react';

const OurLocation = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
      mirror: false,
    });
  }, []);
  const mapUrl = "https://maps.app.goo.gl/eB3TZS1g37GTBd9x8";
  const embedUrl = "https://maps.google.com/maps?q=-8.507721452251761,115.27134451349355&hl=en&z=15&output=embed";

  const locations = [
    {
      name: "Iraga Coffee - Ubud",
      address: "Jl. Raya Andong No.14, Peliatan, Kecamatan Ubud, Kabupaten Gianyar, Bali 80571",
      hours: [
        { day: "Monday - Sunday", time: "07:30 - 22:00" }
      ],
      phone: "+62 811 3888 969",
      email: "ubud@iraga.coffee",
      mapImage: "https://images.unsplash.com/photo-1524661135-423995f22d0b?w=800&h=600&fit=crop"
    }
  ];

  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="relative h-[60vh] min-h-[400px] flex items-center justify-center overflow-hidden">
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: 'url(https://images.unsplash.com/photo-1559925393-8be0ec4767c8?w=1600&h=900&fit=crop)',
            filter: 'brightness(0.6)'
          }}
        />
        <div className="relative z-10 text-center text-white px-4" data-aos="fade-up">
          <h1 className="text-4xl md:text-7xl font-bold mb-6">Our Location</h1>
          <p className="text-xl md:text-2xl max-w-2xl mx-auto">
            Visit us in Ubud, Bali. Experience the warmth of Iraga Coffee in person.
          </p>
        </div>
      </section>

      {/* Map Section */}
      <section className="py-20" style={{ backgroundColor: '#F5F5F0' }}>
        <div className="max-w-7xl mx-auto px-6 sm:px-6 lg:px-8">
          <div className="text-center mb-12" data-aos="fade-up">
            <h2 className="text-3xl md:text-5xl font-bold mb-4" style={{ color: '#31415A' }}>Find Us on Map</h2>
            <p className="text-xl text-gray-600">
              Our location is easily accessible in the heart of Ubud
            </p>
          </div>

          <div className="bg-white rounded-lg shadow-xl overflow-hidden" data-aos="fade-up" data-aos-delay="200">
            <div className="relative w-full h-[500px]">
              <iframe
                src={embedUrl}
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Iraga Coffee Location"
              />
            </div>
          </div>
        </div>
      </section>


      {/* CTA Section */}
      <section className="py-20" style={{ backgroundColor: '#31415A' }}>
        <div className="max-w-4xl mx-auto px-6 sm:px-6 lg:px-8 text-center" data-aos="fade-up">
          <h2 className="text-3xl md:text-5xl font-bold mb-6 text-white">
            We Can't Wait to See You!
          </h2>
          <p className="text-xl text-white/90 mb-8">
            Drop by anytime during our operating hours. No reservation needed.
            Come as you are, leave feeling inspired.
          </p>
        </div>
      </section>
    </div>
  );
};

export default OurLocation;
